import { render } from "./AppSubHeaderIndex.vue?vue&type=template&id=3a1d67be"
import script from "./AppSubHeaderIndex.vue?vue&type=script&lang=js"
export * from "./AppSubHeaderIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__